import { render, staticRenderFns } from "./ModFreqs.vue?vue&type=template&id=30182a10&scoped=true&"
import script from "./ModFreqs.vue?vue&type=script&lang=js&"
export * from "./ModFreqs.vue?vue&type=script&lang=js&"
import style0 from "./ModFreqs.vue?vue&type=style&index=0&id=30182a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30182a10",
  null
  
)

/* custom blocks */
import block0 from "./ModFreqs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports